import { useContext } from "react";
import { UserContextContext } from "@vp/ubik-context";

/**
 * A safe alternative to useUserContext() that returns undefined
 * instead of throwing when UserContextProvider is not available.
 * This supports integrations outside of Ubik (e.g., cart UX Mods).
 */
export const useSafeUserContext = () => {
  const context = useContext(UserContextContext);
  return context?.userContext;
};
